import styled from '@emotion/styled';

/**
 * Shared progress bar preview scaling components
 * 
 * Used to render progress bar widgets at full width (900px) then scale down
 * for preview contexts (chart library, widget selector, save modal, etc.)
 * 
 * This ensures progress bars have readable labels and proper spacing
 * instead of being compressed into small preview areas.
 */

export const PREVIEW_PROGRESS_BAR_WIDTH = 900;
export const PREVIEW_PROGRESS_BAR_SCALE = 0.6;

export const ProgressBarScaleWrapper = styled.div({
  width: '100%',
  height: `${PREVIEW_PROGRESS_BAR_WIDTH * PREVIEW_PROGRESS_BAR_SCALE * 0.20}px`,
  overflow: 'hidden',
  position: 'relative',
});

export const ProgressBarScaleContent = styled.div({
  width: `${PREVIEW_PROGRESS_BAR_WIDTH}px`,
  transformOrigin: 'top left',
  transform: `scale(${PREVIEW_PROGRESS_BAR_SCALE})`,
  position: 'absolute',
  top: 0,
  left: 0,
});
